import * as React from 'react';
import { Card, Price } from '@grandvisionhq/common';

const AppointmentProduct = ({ product  })=>{
    const { image , name , price  } = product !== null && product !== void 0 ? product : {};
    return /*#__PURE__*/ React.createElement(Card, {
        key: name,
        layout: "horizontal"
    }, /*#__PURE__*/ React.createElement(Card.Image, {
        src: (image === null || image === void 0 ? void 0 : image.url) || '',
        alt: name !== null && name !== void 0 ? name : '',
        className: "appointment-product__image"
    }), /*#__PURE__*/ React.createElement(Card.Content, {
        center: true
    }, /*#__PURE__*/ React.createElement(Card.Heading, {
        variant: "subheading1",
        component: "h3"
    }, name), (price === null || price === void 0 ? void 0 : price.amount) ? /*#__PURE__*/ React.createElement(Card.Text, null, /*#__PURE__*/ React.createElement(Price, {
        value: price.amount,
        currency: price.currencyCode,
        centAmount: false
    })) : null));
};

export { AppointmentProduct };
//# sourceMappingURL=AppointmentProduct.js.map
